import type { FinanceType } from './financeApi';

export const CAPITAL_CATEGORIES = [
  '초기 자본금',
  '추가 출자',
  '기타 자본',
] as const;

export const EXPENSE_CATEGORIES = [
  '식비(복리후생)',
  '식비(접대비)',
  '인건비/외주비',
  '서버/SaaS구독료',
  '교육훈련비',
  '임대료/관리비',
  '세금/공과금',
  '광고선전비',
  '여비교통비',
  '소모품비/비품',
  '기타지출',
] as const;

export const REVENUE_CATEGORIES = [
  '서비스 구독료',
  '건별 이용료/인앱결제',
  '플랫폼 중개수수료',
  '외주/용역 매출',
  '상품/콘텐츠 판매',
  '광고/입점료',
  '정부지원금',
  '이자수입',
  '기타매출',
] as const;

export const PAYMENT_METHODS = [
  '카카오체크카드',
  '토스체크카드',
  '삼성카드',
  'KB국민카드',
  '현금',
] as const;

export const DEFAULT_PAYMENT_METHOD = PAYMENT_METHODS[0];

/** 재무 데이터 표시 시작 월 (이 이전은 조회/표시하지 않음) */
export const FINANCE_DATA_START_MONTH = '2026-06';

export type PaymentMethod = (typeof PAYMENT_METHODS)[number];

export function isPaymentMethod(value: string): value is PaymentMethod {
  return (PAYMENT_METHODS as readonly string[]).includes(value);
}

export const FINANCE_TYPE_OPTIONS: { value: FinanceType; label: string }[] = [
  { value: 'REVENUE', label: '매출' },
  { value: 'EXPENSE', label: '매입' },
  { value: 'CAPITAL', label: '초기 자본금' },
];

export function getFinanceTypeLabel(type: FinanceType): string {
  return FINANCE_TYPE_OPTIONS.find((option) => option.value === type)?.label ?? type;
}

export function getFinanceCategories(type: FinanceType): readonly string[] {
  if (type === 'REVENUE') return REVENUE_CATEGORIES;
  if (type === 'EXPENSE') return EXPENSE_CATEGORIES;
  return CAPITAL_CATEGORIES;
}

export function getFinanceTypeBadgeClass(type: FinanceType): string {
  if (type === 'REVENUE') return 'finance-dashboard__type-badge--revenue';
  if (type === 'EXPENSE') return 'finance-dashboard__type-badge--expense';
  return 'finance-dashboard__type-badge--capital';
}

export function getFinanceAmountClass(type: FinanceType): string {
  if (type === 'REVENUE') return 'finance-dashboard__amount--revenue';
  if (type === 'EXPENSE') return 'finance-dashboard__amount--expense';
  return 'finance-dashboard__amount--capital';
}

const AUTO_RECURRING_PREFIX = /^\[AUTO-RECURRING(?::\d+)?\]\s?/;

export function isAutoRecurringRecord(description: string | null | undefined) {
  return AUTO_RECURRING_PREFIX.test(String(description || '').trim());
}

export function formatFinanceRecordMemo(description: string | null | undefined) {
  return String(description || '')
    .trim()
    .replace(AUTO_RECURRING_PREFIX, '')
    .trim();
}
